/**
 * 文件说明: 客服考核统计
 * ----------------------------------------
 * 创建用户: 1625
 * 创建日期 2021/03/26
 */

import _ from 'lodash'
import {createProjectModel} from 'message-control/utils/project-model'
import {getList, getExportData, getUpdateTime} from './service'

function formatParams(params) {
    const newParams = {}
    if (params.department_id) {
        newParams.department_id = params.department_id
    }
    if (params.user_id) {
        newParams.user_id = params.user_id
    }
    if (params.date_range?.length) {
        newParams.start_time = `${params.date_range[0]} 00:00:00` || undefined
        newParams.end_time = `${params.date_range[1]} 23:59:59` || undefined
    }
    return newParams
}

const model = createProjectModel({
    projectNamespace: 'kpiStatistic',
    state: {
        tableList: {}, // 带有机器人的群列表
        exportParams: {}, // 导出参数
        updateTime: '', // 更新时间
    },

    effects: {
        *getTableList(__, {select, put, call}) {
            const {tableList} = yield select((allState) => allState[model.namespace])
            const params = formatParams(tableList.params)
            const newParams = {
                offset: tableList.pagination.pageSize * (tableList.pagination.current - 1),
                limit: tableList.pagination.pageSize,
                ...params,
            }
            if (tableList.sorter?.columnKey) {
                newParams.order_by = tableList.sorter?.columnKey
            }

            if (tableList.sorter?.order) {
                newParams.asc = tableList.sorter?.order === 'descend' ? 0 : 1
            }
            const res = yield call(getList, {
                params: {
                    ...newParams,
                },
            })
            res.data.forEach((item, idx) => {
                if (!item.id) {
                    item.id = idx + 1
                }
            })
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableList.dataSource = res.data
                    draft.tableList.pagination.total = _.get(res, 'pagination.rows_found', 0)
                    draft.exportParams = {...params}
                },
            })
        },
        *getUpdateTime(__, {put, call}) {
            const res = yield call(getUpdateTime)
            if (res.data) {
                yield put({
                    type: 'immerCb',
                    payload: (draft) => {
                        draft.updateTime = res.data
                    },
                })
            }
        },

        *exportRecords(__, {select, call}) {
            const {exportParams} = yield select((allState) => allState[model.namespace])
            return yield call(getExportData, {params: exportParams})
        },
    },
})
export default model
